import { useQuery } from "react-query";
import axios from "infra/http";
import { ContasRecorrentesDashboard, ContaRecorrenteParams } from "../typings";

function useContasRecorrentesDashboard(params: ContaRecorrenteParams) {
  return useQuery(`/v1/conta-recorrente/dashboard`, async () => {
    const { data } = await axios.get<ContasRecorrentesDashboard>(
      `/v1/conta-recorrente/dashboard`,
      {
        params,
      }
    );

    return data;
  });
}

export default useContasRecorrentesDashboard;
